import * as ActionTypes from '../../constants/actiontypes/backoffice/dossiers';
import * as Loadings from '../../constants/loadings/backoffice/dossiers';
import * as R from 'ramda';
import User from '../../constants/models/user';
import BackofficeUser from '../../constants/models/backofficeUser';
import Partner from '../../constants/models/backoffice/partner';


const DossiersReducer = (state = {
    isLoading: [],
    dossiers: undefined,
    partners: undefined,
    totalPages: 0,
    totalRecords: 0,
    currentPage: 0,
    globalFilters: {
        status: undefined,
        partner: {
            id: undefined,
            name: undefined
        },
        order: {
            column: "lastName",
            asc: false
        },
        search: ""
    }

}, action) => {
    switch (action.type) {

        case ActionTypes.FETCH_USERS_DOSSIERS_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_USERS_DOSSIERS)) {
                state.isLoading = state.isLoading.concat(Loadings.FETCHING_USERS_DOSSIERS);
            }

            return { ...state };

        case ActionTypes.FETCH_USERS_DOSSIERS_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_USERS_DOSSIERS);
            // if ((action.data.pageNumber + 1) === action.data.totalPages) {
            //     state.nextPage = false;
            // } else {
            //     state.nextPage = true;

            // }

            if (state.dossiers) {
                const moreDossiers = action.data.items.map(user => new BackofficeUser(user));
                state.dossiers = [...moreDossiers];
            } else {

                state.dossiers = action.data.items.map(user => new BackofficeUser(user));
            }

            state.totalPages = action.data.totalPages;
            state.totalRecords = action.data.totalRecords;
            state.currentPage = action.data.pageNumber + 1;
            return { ...state };


        case ActionTypes.FETCH_USERS_DOSSIERS_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_USERS_DOSSIERS);
            return { ...state };


        //#region Partner  
        case ActionTypes.FETCH_PARTNERS_DOSSIERS_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_PARTNERS_DOSSIERS)) {
                state.isLoading = state.isLoading.concat(Loadings.FETCHING_PARTNERS_DOSSIERS);
            }

            return { ...state };

        case ActionTypes.FETCH_PARTNERS_DOSSIERS_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_PARTNERS_DOSSIERS);

            state.partners = action.data.map(partner => new Partner(partner));

            return { ...state };
        //#endregion

        case ActionTypes.FETCH_PARTNERS_DOSSIERS_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_PARTNERS_DOSSIERS);
            return { ...state };

        case ActionTypes.SET_DOSSIER_FILTER:
            const newState = { ...state.globalFilters, ...action.data };
            state.globalFilters = newState;
            return { ...state };

        default:
            return state;
    }
};
export default DossiersReducer;